<div class="specific-container">
  <div class="user-name flex-overflow-ellipsis">
    {{ item.result.firstLastName }}
  </div>
  <div class="user-email flex-overflow-ellipsis">{{ item.result.email }}</div>
  <div class="user-entity-name flex-overflow-ellipsis">{{ item.result.entityName }}</div>
  <div class="user-title flex-overflow-ellipsis">{{ item.result.title }}</div>
  <div class="user-phone-number flex-overflow-ellipsis">
    {{ item.result.phoneNumber }}
  </div>
  <div class="user-mobile flex-overflow-ellipsis">{{ item.result.mobile }}</div>
  @if (item.result.external) {
    <div class="user-impe"
      >
      <aa-btn-action-secondary [size]="'small'"
        [btnText]="'BUTTON.IMPERSONATE.ENTER' | translate"
        (click)="onImpersonate($event, item.result)">
      </aa-btn-action-secondary>
    </div>
  }
</div>
